var Curriculog = Curriculog || {};

Curriculog.ManageParentsView = (function ($, _, Backbone, ManageParentsView) {

	ManageParentsView = Curriculog.CurriculogView.extend({
		template: 'HierarchyFlyout/manageParents.html',
		events: {
			'click #entity-parents-add': 'addParent',
		},

		initialize: function (options) {
			this.currentEntityID = options.currentEntityID,
			this.collection = options.collection;
			this.entities = options.entities;
			this.entityParentsCanDelete = options.entityParentsCanDelete;
			this.listenTo(this.collection, 'add', this.updateDropDown);
			this.listenTo(this.collection, 'reset', this.updateDropDown);
			this.listenTo(this.collection, 'remove', this.updateDropDown);
			this.listenTo(this.collection, 'change', this.updateDropDown);
			this.render();
		},

		render: function () {
			var el = nunjucks.render(this.template);
			this.replaceElement(el);
			this.renderDropDown();
			this.renderParents();
		},

		renderDropDown: function () {
			var entity = this.entities.get(this.currentEntityID),
			    subView = {};

			if (entity !== undefined) {
				var entityID = entity.get('id')
				var ancestors = this.collection.getAncestors(entityID);
				var decendants = this.collection.getDecendants(entityID);

				var ineligible = ancestors.concat(decendants);
				ineligible.push(entityID);

				subView = new Curriculog.HierarchyDropdownView({
					collection: this.collection,
					entities: this.entities,
					ineligible: ineligible,
					noAvailableOptionsMessage: 'No eligible parents available',
					id: 'entity-parents-available',
					attributes: {
						name: 'parents'
					},
				});
			} else {
				subView = new Curriculog.HierarchyDropdownView({
					noAvailableOptionsMessage: 'No eligible parents available',
					id: 'entity-parents-available',
					attributes: {
						name: 'parents'
					},
				});
			}

			var entityLabel = $(this.$el).find('label')[0];
			$(subView.el).insertAfter(entityLabel);
			this.entityDropdown = subView;

			if (this.entityDropdown.getCurrentSelection() === 'No eligible parents available') {
				this.$el.find('#entity-parents-add').attr('disabled', 'disabled');
			} else {
				this.$el.find('#entity-parents-add').attr('disabled', false);
			}
		},

		updateDropDown: function () {
            this.entityDropdown.remove();
            this.renderDropDown();
		},

		renderParents: function () {
			var entity = this.entities.get(this.currentEntityID);
			var subView = new Curriculog.ParentListView({
				entity: entity.toJSON(),
				entities: this.entities,
				relationships: this.collection,
				canDelete: this.entityParentsCanDelete,
			});

			var parentsLabel = $(this.$el).find('.label')[0];
			$(subView.el).insertAfter(parentsLabel);
			this.parentList = subView;
		},

		addParent: _.debounce(function () {
			var selectedEntity = $('#entity-parents-available option:selected');
			if (selectedEntity.attr('disabled') !== 'disabled') {
				var newParentID = parseInt(selectedEntity.attr('value'));

				var entity = this.entities.get(this.currentEntityID);
				var parentList = this.collection.getParents(entity.get('id'));

				var view = this;

				if (parentList.length === 0) {
					var relationship = this.collection.getRelationshipsForEntity(this.currentEntityID);
					relationship[0].save({
						entity_parent_id: newParentID,
					}, {
						wait: true,

						error: function () {
							var errorText = 'An error was encountered when adding the parent.  ';
							errorText += 'Please try again or contact an administrator.';
							view.showGrowl(errorText);
						},
						
						success: function () {
							Curriculog.Actions.log('entity-parent-added');
						},
					});
				} else {
					this.collection.create({
						entity_id: entity.get('id'),
						entity_parent_id: newParentID,
					}, {
						wait: true,

						error: function () {
							var errorText = 'An error was encountered when adding the parent.  ';
							errorText += 'Please try again or contact an administrator.';
							view.showGrowl(errorText);
						},
						
						success: function () {
							Curriculog.Actions.log('entity-parent-added');
						},
					});
				}
			}
		}, 250),
	});
	return ManageParentsView;

})($, _, Backbone, Curriculog.ManageParentsView || {});